<template>
    <div>          
        <h4 class="p-2">Finanzas SIM</h4>
        <form autocomplete="off" @submit.prevent="getFinanzasSim()" @keydown.enter="$event.preventDefault()">
        <vs-row class="mt-4">
            <vs-col sm="12" lg="4">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
            </vs-col>
            <vs-col sm="12" lg="4">
                    <label for="institucion" class="labelInput">
                        Nombre o Matrícula SIM
                    </label>
                    <vs-input class="pt-0" v-model="matricula_sim" placeholder="Matrícula SIM">
                        <template #message-danger v-if="errorFields.includes('matricula_sim')">
                            Requerido
                        </template>
                    </vs-input>
            </vs-col>
            <vs-col sm="12" lg="4" style="margin-top: 23px; display: flex">
                <vs-button
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        </form>
        <!-- <vs-row v-if="users.length">
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-button
                    class="ml-auto"
                    success
                    :loading="loadingExcel"
                    @click="getFileBecasAplicas()"
                >
                    Descargar archivo
                </vs-button>
            </vs-col>
        </vs-row> -->

        
        <p v-if="!users[0]" class="sinInfo mt-2">Sin información</p>
        <tabla-finanzas-sim v-else class="mt-2" :users="users"></tabla-finanzas-sim>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import TablaFinanzasSim from './tabla-finanzas-sim.vue'
export default {
    data(){
        return{
            active: 0,
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            matricula_sim: '',
            users: [],
            errorFields: [],
            loadingExcel: false
        }
    },
    components:{
        TablaFinanzasSim,
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
            }
            catch{
                
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.matricula_sim) {
                this.errorFields.push('matricula_sim')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getFinanzasSim() {
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                this.users = []
                try {
                    const params ={
                        "institucion_id": this.institucion,
                        "words": this.matricula_sim
                    }
                    const { data: response } = await reportes.getFinanzasSim(params)
                    response.forEach(element => {
                        const general = []
                        const ans = []
                        const cargosKey = Object.keys(element.cargos)
                        cargosKey.forEach(m => {
                            const obj = {
                                nombre: m,
                                info: element.cargos[m]
                            }
                            ans.push(obj)
                        })
                        general.alumno = element.alumno
                        general.matricula = element.matricula_sim
                        general.cargos = ans
                        this.users.push(general)
                    });
                    // this.users.push(general)
                    loading.close()
                }
                catch(error){
                    console.log(error)
                    loading.close()
                    
                }
            }
        },
        
        async getFileBecasAplicas(){
            this.loadingExcel = true
            const params ={
                "institucion_id": this.institucion,
                "ciclo_escolar_id": this.cicloEscolar,
                "type_response": "file",
                "estatus": this.estatus == 'activo' ? 'activo' : 'inactivo',
            }

            if(this.grupo[0] == ''){
                const eliminarGrupo = this.grupo.shift()
                params.grupos_ids = this.grupo
            }else{
                params.grupos_ids = this.grupo
            }

            if(this.codigoDetalle[0] == ''){
                const eliminarCodigo = this.codigoDetalle.shift()
                params.codigos_detalles_ids = this.codigoDetalle
            }else{
                params.codigos_detalles_ids = this.codigoDetalle
            }
            setTimeout(() => {
                axios.post('/reportesMovimientos/getBecas', params, {
                    responseType: 'blob',
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loadingExcel = false
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
        },
    }
}
</script>
<style scoped>

    .sinInfo{
        padding: 20px;
        text-align: center;
    }
</style>